export type AtsEntryParams = {
  instanceId: string;
  jobId: string | null;
  organizationId: string | null;
};

const readOptional = (params: URLSearchParams, name: string): string | null =>
  params.get(name)?.trim() || null;

// Harvey Nash has not confirmed the parameter names; this is the only reader.
export const parseAtsEntryParams = (search: string): AtsEntryParams | null => {
  const params = new URLSearchParams(search);
  const instanceId = readOptional(params, 'instanceId');

  if (!instanceId) return null;

  return {
    instanceId,
    jobId: readOptional(params, 'jobId'),
    organizationId: readOptional(params, 'organizationId')
  };
};
